<template>
    <div class="widget">
        <vuestic-modal
            :show.sync="modalInfo.show"
            v-bind:force="true"
            ref="modalInfo"
            :cancelText="$t('modal.cancel')"
            :okText="$t('dns.remove')"
            @ok="deleteRecord(modalInfo.record)"
        >
            <div slot="title">{{ modalInfo.title }}</div>
            <div>{{ modalInfo.body }}</div>
        </vuestic-modal>
        <div class="widget-header">
            {{$t('dns.title')}} {{domain.domain}}
        </div>
        <div class="widget-body" style="overflow-x: auto;">

            <!-- Tags e form para cadastrar registros -->
            <tabs>
                
                <tab name="A" :selected="true">
                    <span> {{$t('dns.a_description')}} </span>

                    <div class="domain-record-form">
                        <div class="form-inline ">
                            <div class="mt-3 mb-3 mr-3 hostname">
                                <h4>Hostname</h4>
                                <div class="wrapper">  
                                    <input type="text" class="form-control"
                                    v-model="form.hostname" 
                                    placeholder="Enter @ or hostname">
                                    <span class="clearInput">{{hostnameValidate ? formatedHostname : $t('dns.invalid_hostname')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 ip">
                                <h4>Will direct to</h4>
                                <div class="wrapper">
                                    <input type="text" class="form-control"
                                    v-model="form.ip" 
                                    placeholder="Enter IP">
                                    <span class="clearInput">{{ipValidate ? "✓" : $t('dns.invalid_ip')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 ttl-seconds">
                                <h4>TTL (Seconds)</h4>
                                    <div class="wrapper">  
                                        <input type="number" class="form-control" 
                                        v-model="form.ttl"
                                        min="3600"
                                        placeholder="Enter TTL">
                                        <span class="clearInput">{{ttlValidate ? "✓" : $t('dns.invalid_ttl')}}</span>
                                    </div>
                            </div>
                        </div>
                     <div>
                            <button type="submit" 
                                class="btn btn-success my-4" 
                                @click="createRecord('A')" >
                                {{$t('dns.create_record')}}
                            </button>
                        </div>

                    </div>
                </tab>
                
                <tab name="AAAA">
                    <span> {{$t('dns.aaaa_description')}} </span>
                    <div class="domain-record-form">
                        <div class="form-inline ">
                            <div class="mt-3 mb-3 mr-3 hostname">
                                <h4>Hostname</h4>
                                <div class="wrapper">  
                                    <input type="text" class="form-control"
                                    v-model="form.hostname" 
                                    placeholder="Enter @ or hostname">
                                    <span class="clearInput">{{hostnameValidate ? formatedHostname : $t('dns.invalid_hostname')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 ip">
                                <h4>Will direct to</h4>
                                <div class="wrapper">
                                    <input id="ip" type="text" class="form-control"
                                    v-model="form.ipv6" 
                                    placeholder="Enter IP">
                                    <span class="clearInput">{{ipv6Validate ? "✓" : $t('dns.invalid_ipv6')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 ttl-seconds">
                                <h4>TTL (Seconds)</h4>
                                    <div class="wrapper">  
                                        <input type="number" class="form-control" 
                                        v-model="form.ttl"
                                        min="3600"
                                        placeholder="Enter TTL">
                                        <span class="clearInput">{{ttlValidate ? "✓" : $t('dns.invalid_ttl')}}</span>
                                    </div>
                            </div>
                        </div>
                        <div>
                            <button type="submit" 
                                class="btn btn-success" 
                                @click="createRecord('AAAA')" >
                                {{$t('dns.create_record')}}
                            </button>
                        </div>
                    </div>
                </tab>
                
                <tab name="CNAME">
                    <span> {{$t('dns.cname_description')}} </span>

                    <div class="domain-record-form">
                        <div class="form-inline ">
                            <div class="mt-3 mb-3 mr-3 hostname">
                                <h4>Hostname</h4>
                                <div class="wrapper">  
                                    <input type="text" class="form-control"
                                    v-model="form.hostname" 
                                    placeholder="Enter hostname">
                                    <span class="clearInput">{{hostnameValidate ? formatedHostname : $t('dns.invalid_hostname')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 ip">
                                <h4>Is an alias of</h4>
                                <div class="wrapper">  
                                    <input type="text" class="form-control"
                                    v-model="form.cname"
                                    placeholder="Enter @ or hostname">
                                    <span class="clearInput">{{cnameValidate ? formatedCname : $t('dns.invalid_cname')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 ttl-seconds">
                                <h4>TTL (Seconds)</h4>
                                    <div class="wrapper">  
                                        <input type="number" class="form-control" 
                                        v-model="form.ttl"
                                        min="3600"
                                        placeholder="Enter TTL">
                                        <span class="clearInput">{{ttlValidate ? "✓" : $t('dns.invalid_ttl')}}</span>
                                    </div>
                            </div>
                        </div>
                        <div>
                            <button type="submit" 
                                class="btn btn-success" 
                                @click="createRecord('CNAME')" >
                                {{$t('dns.create_record')}}
                            </button>
                        </div>
                    </div>
                </tab>
                
                <tab name="TXT">
                    <span> {{$t('dns.txt_description')}} </span> 
                     
                    <div class="d-flex flex-row-reverse bd-highlight">
                        <div>
                            <button type="submit" 
                                class="btn btn-success" 
                                @click="createRecord('TXT')" >
                                {{$t('dns.create_record')}}
                            </button>
                        </div>
                    </div>
                    <div class="form-inline ">
                        <div class="mt-3 mb-3 mr-3 w-100">
                            <h4>Value</h4>
                            <div class="wrapper">  
                                <div class="input-group mb-3 ">
                                    <input type="text" class="form-control"
                                    v-model="form.txtdata" 
                                    placeholder="paste TXT string here">
                                    <div class="input-group-append">
                                        <button class="btn btn-sm btn-outline-primary" type="button" @click="addTxt()">Add</button>
                                    </div>
                                </div>
                                <ul id="lista-txt">
                                    <li v-for="(item, key) in form.char_str_list" 
                                        :id="key" :key="key" @click="removeFromTxtList(item)">
                                    {{item}}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="mt-3 mb-3 mr-3 hostname">
                            <h4>Hostname</h4>
                            <div class="wrapper">  
                                <input type="text" class="form-control"
                                v-model="form.hostname" 
                                placeholder="Enter @ or hostname">
                                <span class="clearInput">{{hostnameValidate ? formatedHostname : $t('dns.invalid_hostname')}}</span>
                            </div>
                        </div>

                        <div class="mt-3 mb-3 mr-3 ttl-seconds">
                            <h4>TTL (Seconds)</h4>
                            <div class="wrapper">  
                                <input type="number" class="form-control" 
                                v-model="form.ttl"
                                min="14400"
                                placeholder="Enter TTL">
                                <span class="clearInput">{{ttlValidate ? "✓" : $t('dns.invalid_ttl')}}</span>
                            </div>
                        </div>
                    </div>
                </tab>
                
                <tab name="MX">
                    <span> {{$t('dns.mx_description')}} </span>

                    <div class="domain-record-form">
                        <div class="form-inline ">
                            <div class="mt-3 mb-3 mr-3 hostname">
                                <h4>Hostname</h4>
                                <div class="wrapper">  
                                    <input type="text" class="form-control"
                                    v-model="form.hostname" 
                                    placeholder="Enter @ or hostname">
                                    <span class="clearInput">{{hostnameValidate ? formatedHostname : $t('dns.invalid_hostname')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 ip">
                                <h4>Mail providers mail server</h4>
                                <div class="wrapper">  
                                    <input type="text" class="form-control"
                                    v-model="form.exchange"
                                    placeholder="e.g. aspmx.l.google.com">
                                    <span class="clearInput">{{exchangeValidate ? form.exchange : $t('dns.invalid_exchange')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 preference">
                                <h4>PRIORITY</h4>
                                <div class="wrapper">  
                                    <input type="number" class="form-control" 
                                    v-model="form.preference"
                                    min="0"
                                    placeholder="e. g. 10">
                                    <span class="clearInput">{{preferenceValidate ? "✓" : $t('dns.invalid_preference')}}</span>
                                </div>
                            </div>

                            <div class="mt-3 mb-3 mr-3 ttl-seconds">
                                <h4>TTL (Seconds)</h4>
                                <div class="wrapper">  
                                    <input type="number" class="form-control" 
                                    v-model="form.ttl"
                                    min="3600"
                                    placeholder="Enter TTL">
                                    <span class="clearInput">{{ttlValidate ? "✓" : $t('dns.invalid_ttl')}}</span>
                                </div>
                            </div>
                        </div>

                        <div class="create-record">
                            <button type="submit" 
                                class="btn btn-success" 
                                @click="createRecord('MX')" >
                                {{$t('dns.create_record')}}
                            </button>
                        </div>
                    </div>
                </tab>
            </tabs>

            <!-- Lista de registros -->
            <div>
                <table class="table table-striped first-td-padding">
                    <thead>
                        <tr>
                            <td>{{$t('dns.table.type')}}</td>
                            <td>{{$t('dns.table.hostname')}}</td>
                            <td>{{$t('dns.table.value')}}</td>
                            <td>{{$t('dns.table.ttl')}}</td>
                            <td>{{$t('dns.table.options')}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, key) in records" 
                            :id="key" :key="key" 
                            :data-tooltip-text="formatTooltip(item)">

                            <template v-if="item.is_editing">
                                <td>{{ item.type ? item.type : '' }}</td>
                                <td> <input type="text" class="form-control" v-model="item.name" /> </td>
                                <td> 
                                    <!-- input para cada type -->
                                    <template v-if="item.type == 'A'">
                                        <div class="mt-3 mb-3 mr-3">
                                            <strong class="m-1">Will direct to</strong>
                                            <div class="wrapper">
                                                <input type="text" class="form-control"
                                                v-model="item.address" 
                                                placeholder="Enter IP">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="item.type == 'AAAA'">
                                        <div class="mt-3 mb-3 mr-3">
                                            <strong class="m-1">Will direct to</strong>
                                            <div class="wrapper">
                                                <input type="text" class="form-control"
                                                v-model="item.address" 
                                                placeholder="Enter IP">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="item.type == 'CNAME'">
                                         <div class="mt-3 mb-3 mr-3">
                                            <strong class="m-1">Is an alias of</strong>
                                            <div class="wrapper">  
                                                <input type="text" class="form-control"
                                                v-model="item.cname"
                                                placeholder="Enter @ or hostname">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="item.type == 'MX'">
                                        
                                        <div class="mt-3 mb-3 mr-3">
                                            <strong class="m-1">Mail providers mail server</strong>
                                            <div class="wrapper">  
                                                <input type="text" class="form-control"
                                                v-model="item.exchange"
                                                placeholder="e.g. aspmx.l.google.com">
                                            </div>
                                        </div>

                                        <div class="mt-3 mb-3 mr-3">
                                            <strong class="m-1">PRIORITY</strong>
                                            <div class="wrapper">  
                                                <input type="number" class="form-control" 
                                                v-model="item.preference"
                                                min="0"
                                                placeholder="e. g. 10">
                                            </div>
                                        </div>
                                    </template>
                                    <template v-if="item.type == 'TXT'">
                                        <div class="mt-3 mb-3 mr-3 w-100">
                                            <div class="wrapper">  
                                                <div class="input-group mb-3 ">
                                                    <input type="text" class="form-control"
                                                    v-model="item.txtdata" 
                                                    placeholder="paste TXT string here">
                                                    <div class="input-group-append">
                                                        <button class="btn btn-sm btn-outline-primary" type="button" @click="addEditTxt(item)">Add</button>
                                                    </div>
                                                </div>
                                                <ul id="lista-txt">
                                                    <li v-for="(itemTxt, key) in item.char_str_list" 
                                                        :id="key" :key="key" @click="() => { item.char_str_list = item.char_str_list.filter(e => e!=itemTxt) }">
                                                    {{itemTxt}}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </template>
                                    
                                </td>
                                <td> 
                                    <input type="number" class="form-control" 
                                        v-model="item.ttl"
                                        :min="minTTL(item)"
                                        placeholder="Enter TTL">
                                </td>

                                <td class="actions">
                                     <button type="submit" 
                                        class="btn btn-success btn-sm" 
                                        @click="updateRecord(item)" >
                                        {{$t('dns.update_record')}}
                                    </button>
                                    <button type="submit" 
                                        class="btn btn-danger btn-sm" 
                                        @click="cancel(item)" >
                                        {{$t('dns.cancel')}}
                                    </button>
                                </td>

                            </template>

                            <template v-else>
                                <td>{{ item.type ? item.type : '' }}</td>
                                <td>{{ item.name ? item.name : '' }}</td>
                                <td v-html="formatedTableValue(item)"> - </td>
                                <td>{{ item.ttl ? item.ttl : '' }}</td>

                                <td class="actions">
                                    <button class="btn btn-primary btn-micro btn-with-icon rounded-icon" @click="edit(item)">
                                        <i class="ion-md-create ion"></i>
                                    </button>
                                    <button class="btn btn-primary btn-micro btn-with-icon rounded-icon" @click="remove(item)">
                                        <i class="ion ion-md-close" style="margin-left: 3px;"></i>
                                        </button>
                                </td>
                            </template>

                        </tr>
                    </tbody>
                </table>
            </div>
        
        </div>
    </div>
</template>

<script>
import { getAxios } from 'services/ajax'
import store from '../../store'
import tabs from '../../components/tabs/tabs'

export default {
    data () {      
        return {
            domain: {},
            soa: {},
            records: [],
            form: {
                hostname: '',
                ip: '',
                ipv6: '',
                ttl: 3600,
                exchange: '',
                preference: '',
                txtdata: '',
                char_str_list: []
            },
            modalInfo: {
                show: true,
                rule: null,
                title: this.$t('dns.delete_record'),
                body: this.$t('dns.delete_record_confirm'),
            }
        }
    },
    mounted () {
      this.getRecords();
    },
    computed: {
        formatedHostname () {
            if(this.form.hostname === "@"){
                return `${this.domain.domain}.`
            }
            return `${this.form.hostname}.${this.domain.domain}.`
        },
        formatedCname () {
            if(this.form.cname === "@"){
                return `${this.domain.domain}.`
            }
            return this.form.cname
        },
        hostnameValidate () {
            if(!this.form.hostname || this.form.hostname === ""){
                return false;
            }

            if(this.form.hostname === "@"){
                return true;
            }

            const hostnameRegex = /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;

            if(hostnameRegex.test(this.form.hostname)){
                return true;
            }

            return false;
        },
        ipValidate () {
            if(!this.form.ip){
                return true;
            }

            const ipv4Regex = /^((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])($|\/([0-9]|[12][0-9]|3[0-2])$)/

            if (ipv4Regex.test(this.form.ip)){
                return true;
            }

            return false
                        
        },
        ipv6Validate () {
            if(!this.form.ip){
                return true;
            }

            const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))($|\/([0-9]|[12345][0-9]|6[0-4])$)/
           
            if (ipv6Regex.test(this.form.ip)){
                return true;
            }

            return false
                        
        },
        ttlValidate () {
            let minimum = 3600;
            if(this.form.char_str_list.length > 0){
                minimum = 14400;
            }

            if(Number(this.form.ttl) && this.form.ttl >= minimum && this.form.ttl <= 2147483647){
                return true;
            }

            return false;
        },
        preferenceValidate () {
            if(Number(this.form.preference) && this.form.preference >= 0){
                return true;
            }

            return false;
        },
        cnameValidate () {
            if(!this.form.cname){
                return true;
            }

            if(this.form.cname === "@"){
                return true;
            }

            const cnameRegex = /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;

            if(cnameRegex.test(this.form.cname)){
                return true;
            }

            return false;
        },
        exchangeValidate () {
            if(!this.form.exchangeRegex){
                return true;
            }

            const exchangeRegex = /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;

            if(exchangeRegex.test(this.form.exchangeRegex)){
                return true;
            }

            return false;
        }
    },
    methods: {
        minTTL(item) {
            if(item.type && item.type === 'TXT')
                return 14400;
            return 3600;
        },
        getRecords () {
            store.commit('setLoading', true)
        getAxios().get('/customer/domain/' + this.$route.params.dns+'/config')
            .then(response => {
                console.log(response.data)
                this.records = response.data.records
                this.domain = response.data.domain    
                this.soa = response.data.soa          
            })
            .catch(err => {
                if (err.response) {
                    console.log(err)
                }
            })
            .finally(response => store.commit('setLoading', false))
        },
        createRecord (type) {

            const payload = this.formatPayload(type);

            if(this.validateStore(type)){
                store.commit('setLoading', true)
                getAxios().post(`/customer/domain/${this.domain.id}/record/${this.soa.serial}`, payload)
                .then(response => {
                    this.getRecords();
                    //limpando os campos
                    this.form.hostname = ''
                    this.form.ip = ''
                    this.form.ipv6 = ''
                    this.form.ttl = 3600
                    this.form.cname = ''
                    this.form.preference = ''
                    this.form.exchange = ''
                    this.form.txtdata = ''
                    this.form.char_str_list = []
                    
                    if(response.data.metadata.result){
                        this.showToast(this.$t('dns.create_record_success'), {
                            icon: 'fa-star-o',
                            position: 'top-center',
                            duration: 3000,
                            fullWidth: false
                        })
                    }else{
                        this.showToast(this.$t('dns.create_record_error'), {
                            icon: 'fa-remove',
                            position: 'top-center',
                            duration: 3000,
                            fullWidth: false
                        })
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err)
                    }
                    this.showToast(this.$t('dns.create_record_error'), {
                        icon: 'fa-remove',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                    })
                })
                .finally(response => store.commit('setLoading', false))

            }else{
                
                this.showToast(this.$t('dns.invalid_record'), {
                    icon: 'fa-remove',
                    position: 'top-center',
                    duration: 3000,
                    fullWidth: false
                })
            }
        },
        deleteRecord (whm_record) {
            store.commit('setLoading', true)
            const id = whm_record.Line;
            getAxios().delete('/customer/domain/' + this.domain.id + '/record/' + id)
            .then(response => {
                this.records = this.records.filter(record => record.Line !== id)
                this.getRecords();

                if(response.data.metadata.result){
                    this.showToast(this.$t('dns.delete_record_success'), {
                        icon: 'fa-star-o',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                    })    
                }else{
                    this.showToast(this.$t('dns.delete_record_error'), {
                        icon: 'fa-remove',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                    })
                }
                
            })
            .catch(err => {
                if (err.response) {
                    console.log(err)
                }
                this.showToast(this.$t('dns.delete_record_error'), {
                    icon: 'fa-remove',
                    position: 'top-center',
                    duration: 3000,
                    fullWidth: false
                })
            })
            .finally(response => store.commit('setLoading', false))
        },
        updateRecord (item) {
            const id = item.Line;

            const payload = this.formatPayload(item.type, item);

            if(this.validateEdition(item)){
            store.commit('setLoading', true)
                getAxios().put(`/customer/domain/${this.domain.id}/record/${this.soa.serial}/line/${id}`, payload)
                .then(response => {
                    this.getRecords();
                    if(response.data.metadata.result){
                        this.showToast(this.$t('dns.update_record_success'), {
                            icon: 'fa-star-o',
                            position: 'top-center',
                            duration: 3000,
                            fullWidth: false
                        })
                    }else{
                        this.showToast(this.$t('dns.update_record_error'), {
                            icon: 'fa-remove',
                            position: 'top-center',
                            duration: 3000,
                            fullWidth: false
                        })
                    }
                })
                .catch(err => {
                    if (err.response) {
                        console.log(err)
                    }
                    this.showToast(this.$t('dns.update_record_error'), {
                        icon: 'fa-remove',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                    })
                })
                .finally(response => store.commit('setLoading', false))
            }else{
                this.showToast(this.$t('dns.invalid_record'), {
                    icon: 'fa-remove',
                    position: 'top-center',
                    duration: 3000,
                    fullWidth: false
                })
            }
        },
        removeFromTxtList(item){
            this.form.char_str_list = this.form.char_str_list.filter(e => e!=item)
        },
        edit (item) {
            this.$set(item, 'is_editing', true)
            this.$set(item, 'txtdata', '')
        },
        cancel (item) {
            this.$set(item, 'is_editing', false)
        },
        remove (record) {
            this.modalInfo.record = record
            this.$refs.modalInfo.open()
        },
        formatTooltip (item){
            let text = ``;
            Object.entries(item).forEach(prop => {
                text += `[${prop[0]}: ${prop[1]}]\n`
            })
            return text;
        },
        formatedTableValue (item) {
            if(item.address){
                return item.address;
            }
            if(item.cname){
                return item.cname;
            }
            if(item.exchange){
                return `<span>Exchange: <strong>${item.exchange} </strong><br>Preference: <strong>${item.preference}</strong></span>`;
            }

            if(item.char_str_list.length > 0){
                return item.char_str_list.join('<br><hr>')           
            }
            return "";
        },
        addTxt () {
            if (!this.form.txtdata) {
                return;
            }
      
            this.form.char_str_list.push(this.form.txtdata);
            this.form.txtdata = '';
        },
        addEditTxt (item) {
            if (!item.txtdata) {
                return;
            }
      
            item.char_str_list.push(item.txtdata);
            item.txtdata = '';
        },
        validateStore(type, item) {
            
            switch (type) {
                case 'A':
                    return this.ipValidate && this.hostnameValidate;
                case 'AAAA':
                    return this.ipv6Validate && this.hostnameValidate;
                case 'CNAME':
                    return this.cnameValidate && this.hostnameValidate;
                case 'MX':
                    return this.exchangeValidate && this.hostnameValidate;
                case 'TXT':
                    return this.hostnameValidate;
                default:
                    return false;
            }
        },
        validateEdition (item) {
            let dname = false;
            let ttl = false;
            let data = false;

            const hostnameRegex = /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;
            const ipv4Regex = /^((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])($|\/([0-9]|[12][0-9]|3[0-2])$)/
            const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))($|\/([0-9]|[12345][0-9]|6[0-4])$)/
            const cnameRegex = /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;
            const exchangeRegex = /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/;
            
            
            let l = item.name.length; // length of the original string
            let lastChar = item.name.substring(l-1, l); // get the last char of the original string
            if (lastChar == ".") { // if the last char is dot, remove the last char
                item.name = item.name.substring(0, l-1);
            }

            if(hostnameRegex.test(item.name)){
                dname =  true;
            }

            if(item.type == 'A'){
                data = ipv4Regex.test(item.address)
            }
            if(item.type == 'AAAA'){
                data = ipv6Regex.test(item.address)
            }
            if(item.type == 'CNAME'){
                data = cnameRegex.test(item.address)
            }
            if(item.type == 'MX'){
                if(exchangeRegex.test(item.exchange) && Number(this.form.preference) && this.form.preference >= 0){
                    data = true;
                }
            }
            if(item.type == 'TXT'){
                data = item.char_str_list.length > 0;
            }

            if(Number(this.form.ttl) && this.form.ttl >= 3600 && this.form.ttl <= 2147483647){
                ttl = true;
            }
        
            if(dname && ttl && data){
                return true;
            }
            return false;

        },
        formatPayload (type, item = 'new') {
            let payload = null;

            if(item == 'new'){
                payload = {
                    dname: this.formatedHostname,
                    ttl: this.form.ttl,
                    record_type: type
                }
                var ipv6 = this.form.ipv6
                var cname = this.formatedCname
                var exchange = this.form.exchange
                var ip = this.form.ip
                var preference = this.form.preference
                var char_str_list = this.form.char_str_list
            }else{
                payload = {
                    dname: item.name,
                    ttl: item.ttl,
                    record_type: type,
                    line_index: (item.Line - 1)
                }
                var ipv6 = item.ipv6
                var cname = item.cname
                var exchange = item.exchange
                var ip = item.ip
                var preference = item.preference
                var char_str_list = item.char_str_list
                var ip = item.address
                var ipv6 = item.address
            }

            switch (type) {
                case 'A':
                    payload.data = [ip];
                    break;               

                case 'AAAA':
                    payload.data = [ipv6];
                    break;

                case 'CNAME':
                    payload.data = [cname];
                    break;

                case 'MX':
                    payload.data = [preference, exchange];
                    break;

                case 'TXT':
                    payload.data = char_str_list;
                    break;
                
                default:
                    break;
            }

            return { data: JSON.stringify(payload) };
            
        }
    }
}
</script>
<style lang="scss" scoped>
  @import "../../sass/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .domain-record-form {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  @include media-breakpoint-down(md) {
    .domain-record-form {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
  }

input {    
    border: 1px solid #c3c3c3 !important;
}
.wrapper {
    position: relative;
}

.wrapper span {
    position: absolute;
    right: 10px;
    font-size: 12px;
}

/* tooltip */
[data-tooltip-text]:hover {
	position: relative;
}

[data-tooltip-text]:hover:after {
	background-color: #000000;
	background-color: rgba(0, 0, 0, 0.8);

	-webkit-box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 0.4);
	-moz-box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 0.4);
	box-shadow: 0px 0px 3px 1px rgba(50, 50, 50, 0.4);

	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;

	color: #FFFFFF;
	font-size: 12px;
	content: attr(data-tooltip-text);

  margin-bottom: 10px;
	top: 130%;
	left: 0;    
	padding: 7px 12px;
	position: absolute;
	width: auto;
	min-width: 50px;
	max-width: 300px;
	word-wrap: break-word;

	z-index: 9999;
}

/** icone de remover de lista */
#lista-txt {
  list-style: none;
  padding: 0;
}
#lista-txt > li {
  padding-left: 1.3em;
}
#lista-txt > li:before {
  content: "\2718";
  display: inline-block;
  margin-left: -1.3em; /* same as padding-left set on li */
  width: 1.3em; /* same as padding-left set on li */
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/dns/DomainConfig.vue